import React, { useState } from "react";
import { Card, Row, Col } from "reactstrap";
import { DatePicker } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import CountUp from "react-countup";
import { useQuery } from "react-query";
import Lottie from "lottie-react";
import ReactApexChart from "react-apexcharts";
import noTransactionAnimation from "../../../../assets/animations/noMoney.json";
import { transactionsStatsMonthYear, transactionsStatsMonthYearMerchant } from "../services/homeAdminApi";

const Transaction = ({ title = "", selectedBusiness, selectedMarchand }) => {
const [selectedDate, setSelectedDate] = useState(dayjs());
const month = String(selectedDate.month() + 1).padStart(2, "0");
  const year = selectedDate.year();

 const { data: transaction = {}, isLoading, isError, error } = useQuery(
  ["transaction-stats", month, year,selectedMarchand],
  () =>selectedMarchand
      ? transactionsStatsMonthYearMerchant(month, year, selectedMarchand)
      : transactionsStatsMonthYear(month, year),
  {
    enabled: !!month && !!year,
  }
);
  const total = transaction?.total || 0;
  const success = transaction?.details?.SUCCESS || 0;
  const rejected = transaction?.details?.REJECTED || 0;
    const encours = transaction?.details?.PENDING || 0;
  const unknown = transaction?.details?.UNKNOWN || 0;
  const onChange = (date) => {
    setSelectedDate(date);
  };
  return (
    <Card className="transaction-card"style={{ borderRadius: "10px",background:"#FFFFFF",border:'none' }}>
      <div className="transaction-header">
        <div style={{ fontWeight: "400", fontSize: "15px", fontFamily: "Poppins", color: "#000000CC" }}>
          {title}
        </div>
      </div>

      <Row className="mb-3">
        <Col md={6}>
          <DatePicker
            style={{ fontWeight: "400", fontSize: "13px", fontFamily: "Poppins", color: "#252525" }}
            prefix={<CalendarOutlined />}
            onChange={onChange}
            picker="month"
            value={selectedDate}
            defaultValue={dayjs()}
            className="transaction-datepicker"
            disabledDate={(current) => current && current > dayjs().endOf("month")}
          />
        </Col>
      </Row>

      {total === 0 ? (
        <div className="no-transaction-container mt-4" style={{ textAlign: "center" }}>
          <Lottie animationData={noTransactionAnimation} loop style={{ width: 200, height: 200 }} />
          <p style={{ marginTop: 10, fontSize: 16, color: "#888" }}>Aucune transaction ce mois 💵</p>
        </div>
      ) : (
        <>
          <div className="transaction-chart-container mt-0">
            <ReactApexChart 
              options={{
                chart: { type: "donut" },
                labels: ["Succès","En cours" ,"Échouées"],
                plotOptions: {
                pie: { startAngle: -90, endAngle: 270,
                donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total transactions',
                    fontSize: '11px',
                    fontWeight:'400',
                    color: '#1B1B1B',
                    formatter: () => total
                  },
                 
                value: {
                  show: true,
                  fontSize: '25px',
                  fontWeight: 700,
                  fontStyle:'bold',
                  color: '#121212',
                  fontFamily: 'Helvetica Neue',
                  lineHeight: '115px',
                  letterSpacing: '0%'
                  }
                }
                }
               },
                },
                fill: { type: "" },
                legend: { position: "bottom" },
                dataLabels: { enabled: false },
                
                colors: ["#5BE159","#d79c12ff", "#ED4343"],
              }}
              series={[success,encours,rejected]}
              type="donut"
              width={310}
              height={200}
            />
          </div>

          <div className="transaction-legend">
            <div className="transaction-legend-item">
              <div>
                <span className="transaction-dot" style={{ backgroundColor: "#5BE159" }}></span>
                <span  style={{ fontWeight: "400", fontSize: "15px", fontFamily: "Poppins", color: "#000000CC" }}>Transactions réussies</span>
              </div>
              <span className="transaction-value">
                <CountUp style={{ fontWeight: "600", fontSize: "15px", fontFamily: "Poppins", color: "#000000CC" }} start={0} end={success} duration={3} />
              </span>
            </div>    
            <div className="transaction-legend-item">
              <div>
                <span className="transaction-dot" style={{ backgroundColor: "#d79c12ff" }}></span>
                <span style={{ fontWeight: "400", fontSize: "15px", fontFamily: "Poppins", color: "#000000CC" }}>Transactions en cours</span>
              </div>
              <span className="transaction-value">
                <CountUp style={{ fontWeight: "600", fontSize: "15px", fontFamily: "Poppins", color: "#000000CC" }}start={0} end={encours} duration={3} />
              </span>
            </div>
            <div className="transaction-legend-item">
              <div>
                <span className="transaction-dot" style={{ backgroundColor: "#ED4343" }}></span>
                <span style={{ fontWeight: "400", fontSize: "15px", fontFamily: "Poppins", color: "#000000CC" }}>Transactions échouées</span>
              </div>
              <span className="transaction-value">
                <CountUp style={{ fontWeight: "600", fontSize: "15px", fontFamily: "Poppins", color: "#000000CC" }}start={0} end={rejected} duration={3} />
              </span>
            </div>
          </div>
        </>
      )}
    </Card>
  );
};

export default Transaction;
